module.exports = __webpack_public_path__ + "img/R.7485befe.jpg";